// extracted by mini-css-extract-plugin
export default {"container":"B8Ciq3JRQo3JDJiGWczS","alert":"LWAC8_HA8EXcrJmAqImz"};